import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';
import { isLocalApi } from 'utils/localApi';

// Returns { archiveJobId } immediately (202); the zip is built by a background
// worker. Without deliveryEmails the caller polls getProjectBankArchiveJobResult
// with the returned id; with them the worker emails a download link instead.
// createDownloadLink (polled jobs only) makes the worker mint the tokenised
// link too, for the user to send on from the project email.
export const startProjectBankArchiveJob = async ({
  projectId,
  fileIds = [],
  folderIds = [],
  formFiles = [],
  deliveryEmails,
  createDownloadLink = false,
}) => {
  const apiPath = `project-bank/${projectId}/start-archive-job`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: {
      fileIds,
      folderIds,
      formFiles,
      ...(deliveryEmails?.length ? { deliveryEmails } : {}),
      ...(createDownloadLink ? { createDownloadLink: true } : {}),
    },
    isLocalApiRequest: isLocalApi(process.env.REACT_APP_LOCAL_API_PROJECT_BANK),
  });

  const response = await axios(signedRequest);

  return response.data;
};
